module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filter-map"
  }, [_c('div', {
    staticClass: "filter-group"
  }, _vm._l((_vm.filters), function(key, index) {
    return _c('map-filter', {
      key: key.id,
      attrs: {
        "list": key,
        "list-placeholder": _vm.allData.filter_placeholders[index]
      },
      on: {
        "filter-change": function($event) {
          return _vm.filterChange($event, index)
        }
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "leaflet-map-wrapper"
  }, [_c('div', {
    ref: "map",
    staticClass: "leaflet-map"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a16469be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/leafletMap.vue
// module id = 285
// module chunks = 37